var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.427 2c-1.314 0-3.022.142-4.564 1.183-1.617 1.092-2.827 3.012-3.4 6.02-.527 2.768-.337 4.723.205 6.214h-2.24v3.5h4.01c.11.368.206.774.252 1.179.094.817-.037 1.332-.324 1.667-1.384 1.615-2.774 4.522-3.28 5.704L8 30h15.927v-3.5H13.013c.47-.857.995-1.702 1.475-2.263 1.213-1.415 1.333-3.233 1.176-4.604a9.73 9.73 0 0 0-.11-.716h5.373v-3.5h-6.719a18.94 18.94 0 0 0-.109-.157l-.085-.121a4.925 4.925 0 0 1-.541-.974c-.268-.67-.528-1.865-.083-4.203.428-2.241 1.218-3.238 1.976-3.75.833-.563 1.875-.713 3.06-.713.639 0 1.505.332 2.433.896a12.713 12.713 0 0 1 2.107 1.615l1.92-2.688a15.7 15.7 0 0 0-2.642-2.03C21.173 2.64 19.789 2 18.427 2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.96bc54f26d0656be63c037df8d623ca4.svg";
export { ForwardRef as ReactComponent };